import styled from 'styled-components';

export const StyledFormsTemplatesRoot = styled.div`
   min-height: 490px;
   height: 100%;
`;
StyledFormsTemplatesRoot.displayName = 'StyledFormsTemplatesRoot';
